<template>
  <Accordion
    :items="accordionItems"
    type="single"
    collapsible
    class="PassengersAccordion"
  >
    <template #header="{ item }">
      <div class="PassengersAccordion-passengerInfo">
        <span class="PassengersAccordion-passengerName">
          {{ item.passenger.name }}
        </span>

        <span v-if="item.passenger.description" class="PassengersAccordion-passengerDescription">
          {{ item.passenger.description }}
        </span>

        <Tag
          v-if="item.passenger.tag"
          size="xs"
          type="information"
          variant="subtle"
        >
          {{ item.passenger.tag }}
        </Tag>
      </div>
    </template>

    <template #content="{ item }">
      <slot name="content" :passenger="item.passenger" />
    </template>
  </Accordion>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Tag from '../../atoms/Tag/Tag.vue';
import Accordion from '../Accordion/Accordion.vue';
import type { PassengersAccordionItem, PassengersAccordionProps } from './PassengersAccordion.model';

const props = defineProps<PassengersAccordionProps>();

const accordionItems = computed<PassengersAccordionItem[]>(() => props.passengers.map((passenger) => ({
  value: passenger.id,
  title: passenger.name,
  content: '',
  passenger,
})));
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .PassengersAccordion {
    &-passengerInfo {
      display: flex;
      align-items: center;
      flex: 1;
      gap: vars.$dimensions-d-2;
      min-inline-size: 0;
    }

    &-passengerName {
      color: vars.$molecules-accordion-title-color;
      font-weight: vars.$typography-weight-strong;
      @include text.text-responsive('sm', 'md');
    }

    &-passengerDescription {
      color: vars.$molecules-accordion-subtitle-color;
      @include text.text('sm');
    }
  }
}
</style>
